export const config = {
        clientId: "34f5cbd2-da9c-465b-85d6-dd8fb224b5b1",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: "https://eprodx.ai/register",
        scopes: ['User.Read'] 
};
